import {useState} from "react";
import {detectBrowser} from "../utils/util-functions";

export function useDetectBrowser() {
    const [browser, setBrowser] = useState<number>(detectBrowser());

    return browser;
}